import {
  EVENT_GAME_CATEGORY,
  EVENT_GAME_CATEGORY_NAME,
  EVENT_GAME_CATEGORY_TYPE
} from 'src/config/event/eventConfig';
import { AllGamesIcon } from 'src/svg/game-categories/AllGames';
import { BaccaratIcon } from 'src/svg/game-categories/Baccarat';
import { BlackjackIcon } from 'src/svg/game-categories/Blackjack';
import { BonusIcon } from 'src/svg/game-categories/Bonus';
import { BookIcon } from 'src/svg/game-categories/Book';
import { DropsWinsIcon } from 'src/svg/game-categories/DropsWins';
import { FavoriteIcon } from 'src/svg/game-categories/Favorite';
import { FruitsIcon } from 'src/svg/game-categories/Fruits';
import { InstantIcon } from 'src/svg/game-categories/Instant';
import { LiveIcon } from 'src/svg/game-categories/Live';
import { LiveNewIcon } from 'src/svg/game-categories/LiveNew';
import { LiveTopIcon } from 'src/svg/game-categories/LiveTop';
import { MegawaysIcon } from 'src/svg/game-categories/Megaways';
import { NewIcon } from 'src/svg/game-categories/New';
import { EventCategoryIcon } from 'src/svg/game-categories/EventCategoryIcon';
import { PokerIcon } from 'src/svg/game-categories/Poker';
import { RouletteIcon } from 'src/svg/game-categories/Roulette';
import { TableIcon } from 'src/svg/game-categories/Table';
import { TopIcon } from 'src/svg/game-categories/Top';
import { JackpotsIcon } from 'src/svg/game-categories/JackpotsIcon';
import { JackpotMiniIcon } from 'src/svg/game-categories/JackpotMiniIcon';
import { JackpotMidIcon } from 'src/svg/game-categories/JackpotMidIcon';
import { JackpotGrandIcon } from 'src/svg/game-categories/JackpotGrandIcon';
import { SlotsIcon } from 'src/svg/game-categories/Slots';
import { PragmaticPlayIcon } from 'src/svg/game-categories/PragmaticPlayIcon';

type gameCategoriesPathType =
  | `/games/${GameCategoryName}`
  | '/games'
  | `/games/live/${GameCategoryName}`;

export type GameCategoriesParams = {
  param: string;
  title: string;
  path: gameCategoriesPathType;
  image: JSX.Element;
  liveSource?: boolean;
};

export type GameCategoryName =
  | 'all'
  | 'jackpots-games'
  | 'jackpot-bronze'
  | 'jackpot-silver'
  | 'jackpot-gold'
  | 'new'
  | 'top'
  | 'live'
  | 'megaways'
  | 'dropswin'
  | 'blackjack'
  | 'baccarat'
  | 'roulette'
  | 'bonus-games'
  | 'books'
  | 'instant'
  | 'live-top'
  | 'live-new'
  | 'fruits'
  | 'poker'
  | 'table'
  | 'favorites'
  | 'slots'
  | 'pragmatic-play'
  | EVENT_GAME_CATEGORY_TYPE;

export const GAME_CATEGORIES: Record<GameCategoryName, GameCategoriesParams> = {
  all: {
    param: 'all',
    title: 'categoriesItem.all',
    path: '/games',
    image: <AllGamesIcon />
  },
  slots: {
    param: 'slots',
    title: 'categoriesItem.slots',
    path: '/games',
    image: <SlotsIcon />
  },
  new: {
    param: 'new',
    title: 'categoriesItem.new',
    path: '/games/new',
    image: <NewIcon />
  },
  top: {
    param: 'top',
    title: 'categoriesItem.sidebarTop',
    path: '/games/top',
    image: <TopIcon />
  },
  live: {
    param: 'live',
    title: 'categoriesItem.sidebarLive',
    path: '/games/live',
    image: <LiveIcon />,
    liveSource: true
  },
  megaways: {
    param: 'megaways',
    title: 'categoriesItem.megaways',
    path: '/games/megaways',
    image: <MegawaysIcon />
  },
  dropswin: {
    param: 'dropwinscat',
    title: 'categoriesItem.dropWins',
    path: '/games/dropswin',
    image: <DropsWinsIcon />
  },
  blackjack: {
    param: 'blackjack',
    title: 'categoriesItem.blackjack',
    path: '/games/live/blackjack',
    image: <BlackjackIcon />
  },
  baccarat: {
    param: 'baccarat',
    title: 'categoriesItem.baccarat',
    path: '/games/live/baccarat',
    image: <BaccaratIcon />
  },
  roulette: {
    param: 'roulette',
    title: 'categoriesItem.roulette',
    path: '/games/live/roulette',
    image: <RouletteIcon />
  },
  'bonus-games': {
    param: 'bonus-games',
    title: 'categoriesItem.bonus',
    path: '/games/bonus-games',
    image: <BonusIcon />
  },
  books: {
    param: 'books',
    title: 'categoriesItem.books',
    path: '/games/books',
    image: <BookIcon />
  },
  instant: {
    param: 'instant',
    title: 'categoriesItem.instant',
    path: '/games/instant',
    image: <InstantIcon />
  },
  'live-top': {
    param: 'top',
    title: 'categoriesItem.sidebarLiveTop',
    path: '/games/live/top',
    image: <LiveTopIcon />,
    liveSource: true
  },
  'live-new': {
    param: 'new',
    title: 'categoriesItem.sidebarLiveNew',
    path: '/games/live/new',
    image: <LiveNewIcon />,
    liveSource: true
  },
  fruits: {
    param: 'fruits',
    title: 'categoriesItem.sidebarFruits',
    path: '/games/fruits',
    image: <FruitsIcon />
  },
  poker: {
    param: 'poker',
    title: 'categoriesItem.sidebarPoker',
    path: '/games/live/poker',
    image: <PokerIcon />
  },
  table: {
    param: 'table_games',
    title: 'categoriesItem.sidebarTable',
    path: '/games/live/table',
    image: <TableIcon />
  },
  favorites: {
    param: 'favorites',
    title: 'categoriesItem.favorite',
    path: '/games/favorites',
    image: <FavoriteIcon />
  },
  'jackpots-games': {
    param: 'jackpots',
    title: 'jackpots.allJackpots',
    path: '/games/jackpots-games',
    image: <JackpotsIcon />
  },
  'jackpot-bronze': {
    param: 'jackpot-bronze',
    title: 'jackpots.bronze',
    path: '/games/jackpot-bronze',
    image: <JackpotMiniIcon />
  },
  'jackpot-silver': {
    param: 'jackpot-silver',
    title: 'jackpots.silver',
    path: '/games/jackpot-silver',
    image: <JackpotMidIcon />
  },
  'jackpot-gold': {
    param: 'jackpot-gold',
    title: 'jackpots.gold',
    path: '/games/jackpot-gold',
    image: <JackpotGrandIcon />
  },
  'pragmatic-play': {
    param: 'pragmatic_play',
    title: 'Pragmatic Play',
    path: '/games/pragmatic-play',
    image: <PragmaticPlayIcon />
  },
  [EVENT_GAME_CATEGORY]: {
    param: EVENT_GAME_CATEGORY,
    title: EVENT_GAME_CATEGORY_NAME,
    path: `/games/${EVENT_GAME_CATEGORY}`,
    image: <EventCategoryIcon />
  }
};

export const gamesList: GameCategoriesParams[] = [
  GAME_CATEGORIES.favorites,
  GAME_CATEGORIES.all,
  GAME_CATEGORIES[EVENT_GAME_CATEGORY],
  GAME_CATEGORIES['jackpots-games'],
  GAME_CATEGORIES.top,
  GAME_CATEGORIES.new,
  GAME_CATEGORIES.megaways,
  GAME_CATEGORIES['pragmatic-play'],
  GAME_CATEGORIES['bonus-games'],
  GAME_CATEGORIES.instant,
  GAME_CATEGORIES.dropswin,
  GAME_CATEGORIES.books,
  GAME_CATEGORIES.fruits
];

export const jackpotSwitcherGamesList: GameCategoriesParams[] = [
  GAME_CATEGORIES.all,
  GAME_CATEGORIES['jackpots-games'],
  GAME_CATEGORIES['jackpot-gold'],
  GAME_CATEGORIES['jackpot-silver'],
  GAME_CATEGORIES['jackpot-bronze']
];

export const liveGamesList: GameCategoriesParams[] = [
  GAME_CATEGORIES.live,
  GAME_CATEGORIES['live-top'],
  GAME_CATEGORIES['live-new'],
  GAME_CATEGORIES.blackjack,
  GAME_CATEGORIES.baccarat,
  GAME_CATEGORIES.poker,
  GAME_CATEGORIES.roulette,
  GAME_CATEGORIES.table
];

export const jackpotGamesList: GameCategoriesParams[] = [
  GAME_CATEGORIES['jackpots-games'],
  GAME_CATEGORIES['jackpot-gold'],
  GAME_CATEGORIES['jackpot-silver'],
  GAME_CATEGORIES['jackpot-bronze']
];
